import { heroMeta } from "@/mocks/home";

export default function HeroSection() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:py-24">
        {/* 文 */}
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs font-label tracking-wide text-accent-900">
            <i className="ri-flashlight-line" />
            {heroMeta.eyebrow}
          </span>

          <h1 className="mt-5 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl lg:text-6xl">
            {heroMeta.title}
          </h1>
          <p className="mt-3 font-heading text-lg font-semibold text-primary-600 md:text-xl">
            {heroMeta.subtitle}
          </p>
          <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-700 md:text-base">
            {heroMeta.intro}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => goTo("chapters")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line" />
              {heroMeta.primaryCta}
            </button>
            <button
              type="button"
              onClick={() => goTo("audiobook")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-400 bg-secondary-50 px-6 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-100"
            >
              <i className="ri-headphone-line" />
              {heroMeta.secondaryCta}
            </button>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-6 sm:grid-cols-4">
            {heroMeta.stats.map((s) => (
              <div key={s.label}>
                <dt className="text-xs font-label text-foreground-500">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 图 */}
        <div className="animate-fade-up relative mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative ml-auto w-[78%] overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="h-[380px] w-full md:h-[480px]">
              <img
                src={heroMeta.coverMain}
                alt="善良的女秘书小说封面主视觉"
                title="善良的女秘书 小说全文"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="absolute -bottom-6 left-0 w-[46%] overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-none md:w-[44%]">
            <div className="h-[190px] w-full md:h-[230px]">
              <img
                src={heroMeta.coverSecond}
                alt="善良的女秘书未删减版封面"
                title="善良的女秘书 未删减版"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="absolute -top-4 right-0 hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 md:flex">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-[11px] text-background-50">
              <i className="ri-award-line" />
            </span>
            <span className="text-xs font-label text-foreground-700">本月阅读量第 1</span>
          </div>
        </div>
      </div>
    </section>
  );
}